import * as React from 'react';
import { useState } from 'react';
import { IDatabaseField } from 'src/services/database';
import { FormattedMessage } from 'react-intl';
import './styles.css';

export default (props: { field: IDatabaseField, onChange: (id: string, value: any, add: boolean) => void }) => {

    const handleChange = (event: any, value: string) => {
        const target = event.target;
        const hasValue = !props.field.value || !Array.isArray(props.field.value) || !props.field.value.length
        if (value === 'harmonize.select.all.options') {
            props.field.options.forEach(x => {
                if ((hasValue === target.checked) || (props.field.value && target.checked !== props.field.value.includes(x)))
                    props.onChange(props.field.id, x, target.checked);
            })
        } else if ((hasValue === target.checked) || (props.field.value && target.checked !== props.field.value.includes(value)))
            props.onChange(props.field.id, value, target.checked);
    };

    let extra: any = {}
    try {
        extra = JSON.parse(props.field.extra)
    } catch (ex) { }

    return (
        <div className="formrow">
            <div className="formcol">
                <label className="text-muted font-weight-bold"><u>{props.field.label}{props.field.required ? '*' : ''}</u></label>
                <small className="form-text text-muted pb-3">{extra && extra.help}</small>
                <div className="allGradescoll">
                    <label className="pb-3 pt-2 small">
                        <input onChange={(e) => handleChange(e, 'harmonize.select.all.options')} type="checkbox" checked={!!(props.field.value && Array.isArray(props.field.value) && props.field.value.length === props.field.options.length)} />
                        <FormattedMessage
                            id="pages.field.multi.all"
                            defaultMessage="All {fieldName}"
                            values={{ fieldName: props.field.label }} />
                    </label>
                </div>
                <div className="gradescol">
                    <ul>
                        {props.field.options.map(x => {
                            return <li key={x}><label className="small"><input onChange={(e) => handleChange(e, x)} name={props.field.name} type="checkbox" value={x} checked={!!(props.field.value && props.field.value.includes(x))} />{x}</label></li>
                        })}
                    </ul>
                </div>
            </div>
        </div>
    )
};


// WEBPACK FOOTER //
// ./src/client/pages/MultiSelect.tsx